import axios from 'axios'
import $api from '@/api/urls'

// 创建一个 axios 实例，设置基础 URL 和默认配置
const apiClient = axios.create({
  headers: {
    'Content-Type': 'application/json',
    'Authorization': localStorage.getItem('token')
  },
  timeout: 120000
})

// 身份验证相关服务
const resultsService = {
  // 获取栏目 - 大会成果左侧菜单
  getSectionMenu() {
    return apiClient.get($api.GET_SECTION_MENU)
  },
  // 获取内容 - 大会成果内容
  getReportsBySection(item,pn,ps) {
    return apiClient.get( $api.GET_REPORTS_BY_SECTION + `/${item.channelNo}/${item.sysCode}/${item.code}/0/${pn}/${ps}`)
  },
  // 下载文件
  downloadFile(fileId) {
    return apiClient.get( $api.DOWNLOAD_FILE + `?fileId=${fileId}&free=1`,{responseType: "arraybuffer"}).then(res => {
        let blob = new Blob([res.data]);
        let str = res.headers['content-disposition'];
        const fileName = str.substr(str.indexOf("=")+1,str.length);
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = decodeURIComponent(fileName);
        link.click();
        window.URL.revokeObjectURL(link.href);
        return res;
    })
  },

  //首页
  getHomePage(params) {
    return apiClient.post( $api.GET_HOME_PAGE, params)
  },
  // 发送记录
  sendRecord(obj) {
    return apiClient.post( $api.SEND_RECORD, obj)
  },
  // 获取下载记录
  getDownloadHistory(params) {
    return apiClient.get( $api.SEND_RECORD,{params: params})
  },
  // 获取文章详情
  getArticleDetail(params) {
    return apiClient.get( $api.GET_ARTICLE_DETAIL + params)
  },
  // 使用ChatGPT API Key
  postGPTAPIKey(params) {
    return apiClient.post( $api.POST_CHATGPT_API_KEY, params)
  },
  // 获取全部文章
  getLatestArticle(params) {
    return apiClient.post( $api.POST_LATEST_ARTICLE, params)
  }
}

export default resultsService 